/* eslint-disable class-methods-use-this */
import * as Yup from 'yup';
import { FormikProps } from 'formik';
import { GpsType } from '../../../../../global/components/layout/layout-models';
import { DemographicAppKeys } from '../../../../../global/models/demographics-model';
import { TcsmEpiApiState } from '../../../../../root/tcsm-model';
import { AnnualEnrollmentKey } from '../../../../annual-enrollment/models/annual-enrollment-models';
import { DomesticPartnerFormAction, DomesticPartnerFormModel } from '../model/domestic-partner-form-models';
import { apiErrorClear } from '../../../../../global/ducks/base-api';
import { appendDocument, formatDate, parseChanged, parsePhone } from '../../../../../global/helpers/form-data-helper';
import { DocumentUploadState } from '../../personal-info/document-upload-models';
import { getDomesticPartners, patchDeath, patchDomesticPartner, patchPersonInfo, postDomesticPartner, putDomesticPartner } from '../../../../../global/ducks/person-prc-api';
import { dispatchSetDomesticPartners, dispatchSetDomesticPartnersFailed } from '../../dependents/dependents-slice';
import { processRequestWithDocumentUpload } from '../../personal-info/document-upload-request';
import { getRequiredText } from '../../../../../global/helpers/transformer';
import { PersonInfoValidationSchema } from '../../../../../global/validation-schemas/account-information-form-validation';
import { PersonInfoMailingAddressValidationSchema } from '../../../../../global/validation-schemas/address-form-validation';
import { Dependent } from '../../dependents/dependents-model';
import { createEnrollmentWindow } from '../../mycpg-midyear/helpers/mycpg-midyear-coverage-form-helpers';
import { PointOfContactFormModel, QualifyingEventType } from '../../mycpg-midyear/models/mycpg-mid-year-models';
import { FormTypes, matchedPersonField } from '../../../models/form-models';
import { MyCpgMidYearPersonalInfoAlertTypes } from '../../../../notification/notification-models';
import { getCurrentTimeNY, getFormattedDate, getNumberOfDays } from '../../../../../global/helpers/date-helpers';
import { completePersonType } from '../../../helpers/personal-info-helpers';
import { PersonalInfoPersonTypes } from '../../personal-info/personal-info-models';
import { requiredDocUploadFieldChanged } from '../../../../../global/helpers/doc-upload-helpers';
import { toggleDocumentUpload } from '../../personal-info/document-upload-slice';
import { ApiStatuses, YesNoIndicators } from '../../../../../global/models/api-model';
import { setPatchPersonStatus } from '../../personal-info/personal-info-slice';
import { PersonSearchState, SearchPerson } from '../../../../arc/features/person-search/person-search-model';
import { noSelectPersonId } from '../../../../arc/models/arc-epi-props';


export class DomesticPartnerWizard {

	readonly epiContent: TcsmEpiApiState;

	readonly enrollmentContext: AnnualEnrollmentKey;

	readonly app: DemographicAppKeys;

	readonly dispatch: any;

	readonly history: any;

	readonly currentDomesticPartner: Dependent;

	readonly action: string;

	constructor(epiContent: TcsmEpiApiState, enrollmentContext: AnnualEnrollmentKey, app: DemographicAppKeys, dispatch: any, history: any, currentDomesticPartner: Dependent, action: string) {
		this.epiContent = epiContent;
		this.enrollmentContext = enrollmentContext;
		this.app = app;
		this.dispatch = dispatch;
		this.history = history;
		this.currentDomesticPartner = currentDomesticPartner;
		this.action = action?.toUpperCase();
	}

	public getCurrentDomesticPartner() {
		return this.currentDomesticPartner;
	}

	public getPageDescription(): string {

		return this.epiContent?.relationshipsSettingState?.epiContent?.domesticPartnerPageDescription;
	}

	public getPageHeader(): string {
		return this.epiContent?.relationshipsSettingState?.epiContent?.domesticPartnerPageTitle;
	}


	public isEnrollmentForm(): boolean {
		return this.enrollmentContext === AnnualEnrollmentKey.annualEnrollment || this.enrollmentContext === AnnualEnrollmentKey.participantEnrollment || this.enrollmentContext === AnnualEnrollmentKey.mycpgmidyear;
	}

	public isAnnualEnrollmentForm(): boolean {
		return this.enrollmentContext === AnnualEnrollmentKey.annualEnrollment;
	}

	public getGpsType(): GpsType {

		return GpsType.DOMESTIC_PARTNER;

	}

	public getSubmitButtonText() {
		return this.epiContent?.relationshipsSettingState?.epiContent?.saveButtonText;
	}

	public getCancelButtonText() {
		return this.epiContent?.relationshipsSettingState?.epiContent?.cancelButtonText;
	}


	public preventButtonDisableValidation(): boolean {
		return this.isEnrollmentForm();
	}

	public getInitialFormValue() {
		return {
			formAction: !this.currentDomesticPartner ? null : this.action || DomesticPartnerFormAction.ESTABLISH,
			start_date: this.currentDomesticPartner?.start_date ? getFormattedDate(this.currentDomesticPartner?.start_date) : null,
			end_date: null,
			date_of_death: null,
			entity: '',
			jurisdiction: this.currentDomesticPartner?.jurisdiction || '',
			designation_salutation: this.currentDomesticPartner?.person?.designation_salutation || '',
			first_name: this.currentDomesticPartner?.person?.first_name || '',
			middle_name: this.currentDomesticPartner?.person?.middle_name || '',
			last_name: this.currentDomesticPartner?.person?.last_name || '',
			suffix: this.currentDomesticPartner?.person?.suffix || '',
			known_as: this.currentDomesticPartner?.person?.known_as || '',
			gender: this.currentDomesticPartner?.person?.gender || '',
			gender_identity: this.currentDomesticPartner?.person?.gender_identity || [],
			gender_identity_other: this.currentDomesticPartner?.person?.gender_identity_other || '',
			date_of_birth: this.currentDomesticPartner?.person?.masked_date_of_birth || null,
			tax_id: this.currentDomesticPartner?.person?.masked_tax_id || '',
			mailing_address_1: this.currentDomesticPartner?.person?.masked_mailing_address_1 || '',
			mailing_address_2: this.currentDomesticPartner?.person?.masked_mailing_address_2 || '',
			mailing_address_3: this.currentDomesticPartner?.person?.masked_mailing_address_3 || '',
			mailing_country: this.currentDomesticPartner?.person?.mailing_country || '',
			mailing_city: this.currentDomesticPartner?.person?.mailing_city || '',
			mailing_state: this.currentDomesticPartner?.person?.mailing_state || '',
			mailing_postal_code: this.currentDomesticPartner?.person?.mailing_postal_code || '',
			home_phone_country_code: this.currentDomesticPartner?.person?.home_phone_country_code || '',
			home_phone_area_code: this.currentDomesticPartner?.person?.home_phone_area_code || '',
			home_phone_number: this.currentDomesticPartner?.person?.home_phone_number || '',
			home_phone_formated: this.currentDomesticPartner?.person?.home_phone_formated || '',
			home_phone_extension: this.currentDomesticPartner?.person?.home_phone_extension || '',

			mobile_phone_country_code: this.currentDomesticPartner?.person?.mobile_phone_country_code || '',
			mobile_phone_area_code: this.currentDomesticPartner?.person?.mobile_phone_area_code || '',
			mobile_phone_number: this.currentDomesticPartner?.person?.mobile_phone_number || '',
			mobile_phone_formated: this.currentDomesticPartner?.person?.mobile_phone_formated || '',
			mobile_phone_extension: this.currentDomesticPartner?.person?.mobile_phone_extension || '',

			personal_email_address: this.currentDomesticPartner?.person?.personal_email_address || '',

			matched_person: false,
			checkbox1: false,
			checkbox2: false,
		};
	}

	public getDomesticPartnerActionOptions(currentDomesticPartner: Dependent) {
		return currentDomesticPartner ? [
			{
				label: this?.epiContent?.relationshipsSettingState?.epiContent?.reportDomesticPartnershipOptionLabel,
				value: DomesticPartnerFormAction.ESTABLISH,
			},
			{
				label: this?.epiContent?.relationshipsSettingState?.epiContent?.dissolutionDomesticPartnershipLabel,
				value: DomesticPartnerFormAction.DISSOLUTION,
			},
			{
				label: this?.epiContent?.relationshipsSettingState?.epiContent?.deathDomesticPartnerLabel,
				value: DomesticPartnerFormAction.DEATH,
			},
		] : [
			{
				label: this?.epiContent?.relationshipsSettingState?.epiContent?.reportDomesticPartnershipOptionLabel,
				value: DomesticPartnerFormAction.ESTABLISH,
			},
		];
	}

	public getRelationShipSettings() {
		return this?.epiContent?.relationshipsSettingState?.epiContent;
	}

	public getLabelSettings() {
		return this?.epiContent?.labelSettingState?.epiContent;
	}

	public getValidationSchema(showConfirmation: boolean) {

		const validationSchema = Yup.lazy(({
			date_of_birth,
			business_phone_formated,
			business_phone_country_code,
			mobile_phone_formated,
			mobile_phone_country_code,
			home_phone_formated,
			home_phone_country_code,
			formAction,
			matched_person,
			start_date,
		}) => {

			const labelSetting = this.getLabelSettings();

			let schema = Yup.object().shape({
				formAction: Yup.string().required(getRequiredText(labelSetting.requiredFormat, this.getRelationShipSettings()?.reportDomesticPartnershipOptionLabel)),
			});

			if (showConfirmation && matched_person && matched_person !== noSelectPersonId) {
				return Yup.object().shape({
					formAction: Yup.string().required(getRequiredText(labelSetting.requiredFormat, this.getRelationShipSettings()?.reportDomesticPartnershipOptionLabel)),
					start_date: Yup.date().nullable().max(new Date(Date.now()), labelSetting.dateFutureError || 'Date cannot be in the future').required(getRequiredText(labelSetting.requiredFormat, this.getRelationShipSettings()?.relationshipStartDateLabel)),
				});
			}

			if (matched_person && matched_person !== noSelectPersonId) {
				return Yup.object().shape({
					formAction: Yup.string().required(getRequiredText(labelSetting.requiredFormat, this.getRelationShipSettings()?.reportDomesticPartnershipOptionLabel)),
					start_date: Yup.date().nullable().max(new Date(Date.now()), labelSetting.dateFutureError || 'Date cannot be in the future').required(getRequiredText(labelSetting.requiredFormat, this.getRelationShipSettings()?.relationshipStartDateLabel)),
				});
			}

			if (formAction === DomesticPartnerFormAction.ESTABLISH) {
				schema = Yup.object().shape({
					formAction: Yup.string().required(getRequiredText(labelSetting.requiredFormat, this.getRelationShipSettings()?.reportDomesticPartnershipOptionLabel)),
					start_date: Yup.date().nullable().max(new Date(Date.now()), labelSetting.dateFutureError || 'Date cannot be in the future').required(getRequiredText(labelSetting.requiredFormat, this.getRelationShipSettings()?.relationshipStartDateLabel)),
					...PersonInfoValidationSchema(
						labelSetting,
						date_of_birth,
						{
							business_phone_formated,
							business_phone_country_code,
							mobile_phone_formated,
							mobile_phone_country_code,
							home_phone_formated,
							home_phone_country_code,
						},
						false, true),
					...PersonInfoMailingAddressValidationSchema(labelSetting),
				});
			}
			if (formAction === DomesticPartnerFormAction.DISSOLUTION) {
				schema = Yup.object().shape({
					formAction: Yup.string().required(getRequiredText(labelSetting.requiredFormat, this.getRelationShipSettings()?.reportDomesticPartnershipOptionLabel)),
					end_date: Yup.date().nullable().max(new Date(Date.now()), labelSetting.dateFutureError || 'Date cannot be in the future').required(getRequiredText(labelSetting.requiredFormat, this.getRelationShipSettings()?.relationshipEndDateLabel)).max(new Date(Date.now()), labelSetting.dateFutureError || 'Date cannot be in the future'),
				});
			}

			if (formAction === DomesticPartnerFormAction.DEATH) {
				schema = Yup.object().shape({
					formAction: Yup.string().required(getRequiredText(labelSetting.requiredFormat, this.getRelationShipSettings()?.reportDomesticPartnershipOptionLabel)),
					date_of_death: Yup.date().nullable().required(getRequiredText(labelSetting.requiredFormat, this.getRelationShipSettings()?.widowedPreliminaryDateDeathLabel))
						.max(new Date(Date.now()), labelSetting.dateFutureError || 'Date cannot be in the future')
						.min(new Date(start_date), this.getRelationShipSettings()?.dateBeforeRelationshipStartError || 'Date cannot be before the relationship starts'),
				});
			}

			return schema;
		});

		return validationSchema;

	}

	public onCancel() {
		return this.history.goBack();
	}

	private clearErrorsAndStatus(dispatch: any, app: string) {

		dispatch(setPatchPersonStatus(ApiStatuses.None, app));
		dispatch(apiErrorClear());
	}

	private onPersonUpdate(formValues: DomesticPartnerFormModel, initialValue: any, guid: string, docUploadState: DocumentUploadState, relationshipPath: string) {

		const withPhoneUpdate = parsePhone(formValues);
		const toUpdate: any = parseChanged(initialValue, withPhoneUpdate, true);

		completePersonType(toUpdate, guid, PersonalInfoPersonTypes.DomesticPartner);

		delete toUpdate.formAction;
		delete toUpdate.checkbox1;
		delete toUpdate.checkbox2;

		if (!docUploadState.documentUploaded && requiredDocUploadFieldChanged(toUpdate, initialValue)) {
			this.dispatch(toggleDocumentUpload(true, this.app));
			return;
		}

		const { start_date, jurisdiction, ...domesticPartnerInfo } = toUpdate;
		delete domesticPartnerInfo.start_date;
		delete domesticPartnerInfo.jurisdiction;

		const hasDomesticPartnerInfoChanges = Object.keys(domesticPartnerInfo).some(key => key !== 'person_type' && key !== 'member_guid');

		const patchDomesticPartnerSuccess = () => {
			this.dispatch(getDomesticPartners(guid, dispatchSetDomesticPartners(this.dispatch, this.app), () => dispatchSetDomesticPartnersFailed(this.dispatch, this.app)));
			this.history.push(`${relationshipPath}?success=${FormTypes.DOMESTIC_PARTNER_UPDATE}`);

		};

		const onDocUploadSuccess = (domesticPartnerChanges: any) => (data) => {
			const withDocuments = appendDocument(domesticPartnerChanges, data?.map(a => a?.data?.doc_id));
			this.dispatch(patchPersonInfo(this.currentDomesticPartner?.person_guid, withDocuments, false, () => patchDomesticPartnerSuccess()));
		};

		const patchPersonWithDocUpload = () => {

			if (docUploadState.stagedDocuments && docUploadState.stagedDocuments.length > 0 && docUploadState.showDocumentUpload) {

				processRequestWithDocumentUpload(docUploadState, this.currentDomesticPartner?.person_guid, this.dispatch, onDocUploadSuccess(toUpdate));

			} else {
				this.dispatch(patchPersonInfo(this.currentDomesticPartner?.person_guid, { ...domesticPartnerInfo }, false, () => patchDomesticPartnerSuccess()));
			}
		};

		if (start_date || hasDomesticPartnerInfoChanges) {
			this.clearErrorsAndStatus(this.dispatch, this.app);
		}

		// if need to patch marital status, do so, then patch spouse person info if need.
		// else, patch person info only
		if (start_date) {

			this.dispatch(patchDomesticPartner(guid, this.currentDomesticPartner?.person_guid, { start_date, jurisdiction }, () => {
				if (hasDomesticPartnerInfoChanges) {
					patchPersonWithDocUpload();
				} else {
					patchDomesticPartnerSuccess();
				}
			}));
		} else if (hasDomesticPartnerInfoChanges) {
			patchPersonWithDocUpload();
		}
	}

	private onEstablishment(formValues: DomesticPartnerFormModel, guid: string, docUploadState: DocumentUploadState, myCpgMidYearPath: string, relationshipPath: string, domesticPartnerPath: string) {

		if (this.currentDomesticPartner) {
			this.onPersonUpdate(formValues, this.getInitialFormValue(), guid, docUploadState, relationshipPath);
			return;
		}

		const withPhoneUpdate = parsePhone(formValues) as DomesticPartnerFormModel;
		const toUpdate = parseChanged(this.getInitialFormValue(), withPhoneUpdate, true);
		const body = {
			...toUpdate,
			date_of_birth: formatDate(formValues.date_of_birth),
			start_date: formatDate(formValues.start_date),
			isMatchPerson: false,
		};

		delete body.formAction;
		delete body.checkbox1;
		delete body.checkbox2;


		const postDomesticPartnerSuccess = () => {
			this.dispatch(getDomesticPartners(guid, dispatchSetDomesticPartners(this.dispatch, this.app), () => dispatchSetDomesticPartnersFailed(this.dispatch, this.app)));
			if (this.app === DemographicAppKeys.myCPG) {
				createEnrollmentWindow(
					guid,
					{
						enrollment_window: {
							qualifying_event: QualifyingEventType.domestic_partnership,
							qualifying_event_date: formatDate(formValues.start_date),
						},
					},
					() => this.history.push(`${myCpgMidYearPath}?alerts=${MyCpgMidYearPersonalInfoAlertTypes.DOMESTIC_PARTNER_ESTABLISH},${MyCpgMidYearPersonalInfoAlertTypes.DOMESTIC_PARTNER_WARNING}`),
					() => {
						this.dispatch(apiErrorClear());
						this.history.push(`${domesticPartnerPath}?success=${FormTypes.MAP_DOMESTIC_PARTNER},${FormTypes.IN_PROGRESS_MID_YEAR_WARNING}`);
					},
					this.dispatch,
				);
			} else {
				this.history.push(`${domesticPartnerPath}?success=${FormTypes.MAP_DOMESTIC_PARTNER}`);
			}

		};

		const postRequest = (payload) => {
			this.dispatch(postDomesticPartner(guid, payload, () => {
				postDomesticPartnerSuccess();
			}));
		};

		const onDocUploadSuccess = (changes: any) => (data) => {
			const withDocuments = appendDocument(changes, data?.map(a => a?.data?.doc_id));
			postRequest(withDocuments);
		};

		// if docs to upload, upload them, then do the patch with the doc information
		if (docUploadState.stagedDocuments && docUploadState.stagedDocuments.length > 0) {
			processRequestWithDocumentUpload(docUploadState, guid, this.dispatch, onDocUploadSuccess(body));
		} else {
			postRequest(body);
		}
	}

	private onDissolution(formValues: DomesticPartnerFormModel, guid: string, docUploadState: DocumentUploadState, myCpgMidYearPath: string, relationshipPath: string, domesticPartnerPath: string) {

		const domesticPartnerId = this.currentDomesticPartner?.person_guid;

		const body = {
			end_date: formatDate(formValues.end_date),
			entity_issuing_dissolution: formValues?.entity,
		};

		const currentDate = getCurrentTimeNY();

		const daysInPast = getNumberOfDays(formValues.end_date, currentDate);
		const successQuery = daysInPast > 30 ? FormTypes.MAP_DOMESTIC_PARTNER_DISSOLUTION_30_PLUS : `${FormTypes.MAP_DOMESTIC_PARTNER_DISSOLUTION},${FormTypes.IN_PROGRESS_MID_YEAR_WARNING}`;
		const dissloutionDomesticPartnerSuccess = () => {
			this.dispatch(getDomesticPartners(guid, dispatchSetDomesticPartners(this.dispatch, this.app), () => dispatchSetDomesticPartnersFailed(this.dispatch, this.app)));
			if (this.app === DemographicAppKeys.myCPG) {
				createEnrollmentWindow(
					guid,
					{
						enrollment_window: {
							qualifying_event: QualifyingEventType.domestic_partnership_dissolution,
							qualifying_event_date: formatDate(formValues.end_date),
						},
					},
					() => this.history.push(`${myCpgMidYearPath}?alerts=${MyCpgMidYearPersonalInfoAlertTypes.DOMESTIC_PARTNER_DISSOLVE},${MyCpgMidYearPersonalInfoAlertTypes.DOMESTIC_PARTNER_WARNING}`),
					() => {
						this.dispatch(apiErrorClear());
						this.history.push(`${domesticPartnerPath}?success=${successQuery}`);
					},
					this.dispatch,
				);
			} else {
				this.history.push(`${domesticPartnerPath}?success=${successQuery}`);
			}
		};

		const dissolutionRequest = (payload) => {
			this.dispatch(patchDomesticPartner(guid, domesticPartnerId, payload, () => {
				dissloutionDomesticPartnerSuccess();
			}));
		};

		const onDocUploadSuccess = (changes: any) => (data) => {
			const withDocuments = appendDocument(changes, data?.map(a => a?.data?.doc_id));
			dissolutionRequest(withDocuments);
		};

		// if docs to upload, upload them, then do the patch with the doc information
		if (docUploadState.stagedDocuments && docUploadState.stagedDocuments.length > 0) {
			processRequestWithDocumentUpload(docUploadState, guid, this.dispatch, onDocUploadSuccess(body));
		} else {
			dissolutionRequest(body);
		}
	}

	private onDeath(
		formValues: DomesticPartnerFormModel,
		guid: string,
		docUploadState: DocumentUploadState,
		relationshipPath: string,
		setShowPointOfContact: (confirm: boolean) => void,
		pointOfContactFormValues?: PointOfContactFormModel) {

		if (!pointOfContactFormValues) {
			setShowPointOfContact(true);
			return;
		}

		let initialPayload: any = {
			preliminary_date_of_death: formatDate(formValues.date_of_death),
		};

		if (pointOfContactFormValues) {
			initialPayload = {
				...initialPayload,
				'dependent_type': pointOfContactFormValues.dependent_type,
			};

			if (pointOfContactFormValues.is_contact_person === YesNoIndicators.Yes) {
				initialPayload = {
					...initialPayload,
					'contact_phone': `${pointOfContactFormValues.your_contact_phone_country_code} ${pointOfContactFormValues.your_contact_phone_formated}`,
					'contact_email': pointOfContactFormValues.your_contact_email,
					'contact_name': `${formValues.first_name}${formValues.middle_name ? ` ${formValues.middle_name} ` : ' '}${formValues.last_name}`,
					'contact_relationship': pointOfContactFormValues.dependent_type,
				};
			} else {
				initialPayload = {
					...initialPayload,
					'contact_phone': `${pointOfContactFormValues.contact_phone_country_code} ${pointOfContactFormValues.contact_phone_number_formated}`,
					'contact_email': pointOfContactFormValues.contact_email,
					'contact_name': pointOfContactFormValues.full_name_contact,
					'contact_relationship': pointOfContactFormValues.relationship_to_deceased,
				};
			}
		}

		const successQuery = this.app === DemographicAppKeys.myCPG ? FormTypes.DOMESTIC_PARTNER_DEATH : FormTypes.MAP_DOMESTIC_PARTNER_DEATH;
		const deathDomesticPartnerSuccess = () => {
			this.dispatch(getDomesticPartners(guid, dispatchSetDomesticPartners(this.dispatch, this.app), () => dispatchSetDomesticPartnersFailed(this.dispatch, this.app)));

			this.history.push(`${relationshipPath}?success=${successQuery}`);
		};

		const deathRequest = (payload) => {
			this.dispatch(
				patchDeath(this.currentDomesticPartner.person_guid, payload, () => {
					deathDomesticPartnerSuccess();
				}));
		};

		const onDocUploadSuccess = (changes: any) => (data) => {
			const withDocuments = appendDocument(changes, data?.map(a => a?.data?.doc_id));
			deathRequest(withDocuments);
		};

		// if docs to upload, upload them, then do the patch with the doc information
		if (docUploadState.stagedDocuments && docUploadState.stagedDocuments.length > 0) {
			processRequestWithDocumentUpload(docUploadState, guid, this.dispatch, onDocUploadSuccess(initialPayload));
		} else {
			deathRequest(initialPayload);
		}
	}


	private onPersonSelect(setSelectedPerson: any, setShowConfirmation: any, person: SearchPerson, formProps: FormikProps<DomesticPartnerFormModel>) {
		this.dispatch(apiErrorClear());
		setSelectedPerson(person);
		formProps.setFieldValue(matchedPersonField, person?.guid);
		setShowConfirmation(true);
		this.onNavigateToTop();
	}

	private handleOsscr(values: DomesticPartnerFormModel, formProps: FormikProps<DomesticPartnerFormModel>, personSearchState: PersonSearchState, selectedPerson: SearchPerson, setSelectedPerson: any, setShowConfirmation: any) {
		if (values?.matched_person &&
			values?.matched_person !== noSelectPersonId &&
			values?.matched_person !== selectedPerson?.guid &&
			personSearchState?.searchResults?.length > 0) {

			const selectedPersonGrid = personSearchState?.searchResults?.find(employee => employee.guid === values?.matched_person);

			if (selectedPersonGrid) {
				this.onPersonSelect(setSelectedPerson, setShowConfirmation, selectedPersonGrid, formProps);
				return true;
			}
		}

		return false;
	}

	private createDomesticPartnerWithOsscrResult(
		guid: string,
		values: DomesticPartnerFormModel,
		selectedPerson: SearchPerson,
		docUploadState: DocumentUploadState,
		relationshipPath: string,
	) {
		this.clearErrorsAndStatus(this.dispatch, this.app);

		const body = {
			start_date: formatDate(values?.start_date),
			guid: selectedPerson?.guid,
		};

		const putDomesticPartnerSuccess = () => {
			this.dispatch(getDomesticPartners(guid, dispatchSetDomesticPartners(this.dispatch, this.app), () => dispatchSetDomesticPartnersFailed(this.dispatch, this.app)));
			this.history.push(`${relationshipPath}?success=${FormTypes.MAP_DOMESTIC_PARTNER}`);
		};

		const putDomesticPartnerRequest = (payload) => {
			this.dispatch(putDomesticPartner(guid, payload, () => {
				putDomesticPartnerSuccess();
			}));
		};

		const onDocUploadSuccess = (changes: any) => (data) => {
			const withDocuments = appendDocument(changes, data?.map(a => a?.data?.doc_id));
			putDomesticPartnerRequest(withDocuments);
		};

		// if docs to upload, upload them, then do the patch with the doc information
		if (docUploadState.stagedDocuments && docUploadState.stagedDocuments.length > 0) {
			processRequestWithDocumentUpload(docUploadState, guid, this.dispatch, onDocUploadSuccess(body));
		} else {
			putDomesticPartnerRequest(body);
		}
	}

	public onSubmit(
		values: DomesticPartnerFormModel,
		formProps: FormikProps<DomesticPartnerFormModel>,
		guid: string,
		docUploadState: DocumentUploadState,
		myCpgMidYearPath: string,
		relationshipPath: string,
		domesticPartnerPath: string,
		personSearchState: PersonSearchState,
		selectedPerson: SearchPerson,
		setSelectedPerson: (searchPerson: SearchPerson) => void,
		setShowConfirmation: (confirm: boolean) => void,
		setShowPointOfContact: (confirm: boolean) => void,
		pointOfContactFormValues?: PointOfContactFormModel,
	) {

		this.dispatch(apiErrorClear());

		if (this.handleOsscr(values, formProps, personSearchState, selectedPerson, setSelectedPerson, setShowConfirmation)) return;

		if (selectedPerson) {
			this.createDomesticPartnerWithOsscrResult(guid, values, selectedPerson, docUploadState, relationshipPath);
			return;
		}

		switch (values?.formAction) {
			case DomesticPartnerFormAction.ESTABLISH:
				this.onEstablishment(values, guid, docUploadState, myCpgMidYearPath, relationshipPath, domesticPartnerPath);
				break;

			case DomesticPartnerFormAction.DISSOLUTION:
				this.onDissolution(values, guid, docUploadState, myCpgMidYearPath, relationshipPath, domesticPartnerPath);
				break;

			case DomesticPartnerFormAction.DEATH:
				this.onDeath(values, guid, docUploadState, relationshipPath, setShowPointOfContact, pointOfContactFormValues);
				break;

			default:
				break;
		}


	}

	public shouldDisableSubmit(values: DomesticPartnerFormModel) {
		if (values?.formAction === DomesticPartnerFormAction.DEATH) {
			return !values?.checkbox1;
		}
		return !values?.checkbox1 || !values?.checkbox2;
	}

	public shouldShowDefaultDocumentUpload(values: DomesticPartnerFormModel) {
		if (this.currentDomesticPartner) {
			return values.formAction === DomesticPartnerFormAction.DISSOLUTION || values.formAction === DomesticPartnerFormAction.DEATH;
		}
		return !!values.formAction;
	}

	public shouldRenderOsccrSearch(values: DomesticPartnerFormModel, showConfirmation: boolean) {
		return this.app === DemographicAppKeys.arc && !this.currentDomesticPartner && values?.formAction === DomesticPartnerFormAction.ESTABLISH && !showConfirmation;
	}

	public onNavigateToTop() {
		window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
	}

	public getCheckBox1Text() {
		return this.app === DemographicAppKeys.myCPG ? this.epiContent?.relationshipsSettingState?.epiContent?.checkBoxOneDescription : this.epiContent?.relationshipsSettingState?.epiContent?.mapCheckBoxOneDescription;
	}

	public getCheckBox2Text() {
		return this.app === DemographicAppKeys.myCPG ? this.epiContent?.relationshipsSettingState?.epiContent?.checkBoxTwoDescription : this.epiContent?.relationshipsSettingState?.epiContent?.mapCheckBoxTwoDescription;

	}
}

